// src/components/EntitySelect.js
// Searchable "اسم الجهة" picker used by سند صرف (payment voucher) create/edit pages.
import React from 'react';
import { Autocomplete, TextField, MenuItem, Stack, Avatar, Box, Typography, Skeleton } from '@mui/material';
import { AccountCircle } from '@mui/icons-material';

const EntitySelect = ({
  entityType,
  options,
  targetId,
  loading,
  disabled,
  onChange,
  fieldSx,
  label = 'اسم الجهة',
}) => {
  const selected = options?.find((opt) => opt.id === targetId) || null;

  if (loading) {
    return (
      <TextField label={label} select fullWidth disabled sx={fieldSx} value="">
        <MenuItem disabled>
          <Stack useFlexGap direction="row" spacing={2} alignItems="center" width="100%">
            <Skeleton variant="circular" width={32} height={32} />
            <Skeleton variant="text" width="60%" />
          </Stack>
        </MenuItem>
      </TextField>
    );
  }

  return (
    <Autocomplete
      options={options || []}
      value={selected}
      disabled={disabled}
      getOptionLabel={(option) => option?.name || ''}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      noOptionsText="لا يوجد نتائج"
      onChange={(event, value) => onChange(value)}
      renderOption={(props, entity) => (
        <MenuItem {...props} key={entity.id}>
          {entityType === 'موظف' ? (
            <Stack useFlexGap direction="row" spacing={2} alignItems="center">
              <Avatar sx={{ width: 32, height: 32, bgcolor: '#4338CA', fontSize: '12px' }}>
                <AccountCircle />
              </Avatar>
              <Box>
                <Typography variant="body2" sx={{ fontFamily: 'Cairo, Tajawal, sans-serif', color: '#1E1B4B' }}>
                  {entity.name}
                </Typography>
                {entity.employee_id && (
                  <Typography variant="caption" sx={{ fontFamily: 'Cairo, Tajawal, sans-serif', color: '#6B7280' }}>
                    رقم الموظف: {entity.employee_id}
                  </Typography>
                )}
              </Box>
            </Stack>
          ) : (
            entity.name
          )}
        </MenuItem>
      )}
      renderInput={(params) => (
        <TextField {...params} label={label} fullWidth sx={fieldSx} />
      )}
    />
  );
};

export default EntitySelect;
